<template><div><h1 id="rfm-anzeige" tabindex="-1"><a class="header-anchor" href="#rfm-anzeige"><span>RFM-Anzeige</span></a></h1>
<p>RFM-Anzeige — Grafische Anzeige der RFM-Auswertung</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In der Adressmaske wird eine Grafik der RFM-Bewertung (RFM=&quot;Recency, Frequency, Monetary Value&quot;) zur entsprechenden Adresse angezeigt. Die Bewertung wird mit den 2 Achsen &quot;Finanzieller Nutzen&quot; und &quot;Aktivität, Engagement, Bindung&quot; sowohl für die Typen &quot;Spende&quot; (blau), wie auch für &quot;Kauf&quot; (grün) durchgeführt:</p>
<p><img src="@source/referenz/i/Rfmadr.jpg" alt="RFM Anzeige"></p>
<p>Für jede Achse sind <RouteLink to="/referenz/refs/ft.refdata.trfmdim.html" title="RFM-Dimensionen">RFM-Dimensionen</RouteLink> definiert. Bei diesen Dimensionen sind <RouteLink to="/referenz/refs/ft.refdata.trfmdimpos.html" title="RFM-Dimensionen, Positionen">Punktetabellen</RouteLink> hinterlegt, deren Summe den Gesamtpunktewert der Achse ergeben.</p>
<h2 id="bereiche" tabindex="-1"><a class="header-anchor" href="#bereiche"><span>Bereiche</span></a></h2>
<p>Die Positionierung kann in die folgenden 4 Bereiche fallen. Die Parametrisierung der Bereichsgrenzen wird in den Systemparametern festgelegt.</p>
<dl>
<dt>A</dt>
<dd>Ambivalente Pro's</dd>
<dt>T</dt>
<dd>Top Pro's</dd>
<dt>G</dt>
<dd>Gefährdete Pro's</dd>
<dt>L</dt>
<dd>Loyale Pro's</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>keine</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.trfmdim.html" title="RFM-Dimensionen">RFM-Dimensionen</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.trfmdimpos.html" title="RFM-Dimensionen, Positionen">RFM-Dimensionen, Positionen</RouteLink></p>
</div></template>


